module.exports = __webpack_public_path__ + "img/res1-m.5048e9e6.png";